import React from 'react';
import ReactDOM from 'react-dom/client';
import AppExternal from './AppExternal';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './storeExternal';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppExternal />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
